import { render } from "./ArticleTooltip.vue?vue&type=template&id=32219c31&scoped=true"
import script from "./ArticleTooltip.vue?vue&type=script&lang=js"
export * from "./ArticleTooltip.vue?vue&type=script&lang=js"

import "./ArticleTooltip.vue?vue&type=style&index=0&id=32219c31&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32219c31"]])

export default __exports__